'use client';

import React from 'react';
import Image from 'next/image';
import WhatsappCTAButton from '@/components/ui/WhatsappCTAButton';

export default function Contato() {
  return (
    <div className="min-h-screen flex flex-col items-center bg-[#FFFBF5]">
      <div className="flex flex-col items-center gap-4 mb-2 sm:mb-0 bg-[#192437] w-full p-8">
        <a href="/">
          <Image
            src="/logo-jb-primary.svg"
            alt="Escritório de advocacia John Bihuna em Biguaçu, SC"
            width={228}
            height={72}
            className="w-[228px] h-[72px]"
          />
        </a>
      </div>
      <div className="p-4 sm:p-8 sm:mt-10 w-full max-w-4xl flex flex-col gap-2">
        <h1 className="text-secondary text-2xl sm:text-4xl font-bold mb-4">
          Contato - Advogado em Biguaçu/SC
        </h1>
        <div className="sm:text-center text-white w-full flex justify-center items-center mt-4">
          <div className="w-[540px]">
            <p className="text-primary text-base font-medium mb-3">
              <strong>Entre em contato com nosso escritório de advocacia em Biguaçu</strong>
            </p>
            <p className="text-primary text-sm font-medium">
              Atendemos clientes em toda Santa Catarina e demais estados do Brasil. Tire suas dúvidas jurídicas com Dr. John Bihuna e receba orientação especializada em Direito Cível, Família, Imobiliário e Tributário. Atendimento presencial ou remoto.
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-6 sm:mt-6 w-full sm:w-auto justify-center p-3">
        <WhatsappCTAButton />
      </div>
    </div>
  );
}
